export default {
  get groups () {
    return [{
      name: 'Preschool',
      req: 'Ages 3-5',
      desc: 'Ages 3-5',
      classes: {
        m: [
          { title: 'Preschool ballet', start: '5:00', end: '5:30' }
        ],
        f: [
          { title: 'Preschool jazz', start: '5:00', end: '5:30' },
          { title: 'Dancing tots', start: '6:00', end: '6:30' }
        ]
      }
    }, {
      name: 'Beginner',
      req: 'Ages 5+',
      desc: 'Ages 5+',
      classes: {
        m: [
          { title: 'Hip Hop', start: '5:30', end: '6:00' },
          { title: 'Lyrical 2', start: '6:00', end: '6:45' }
        ],
        t: [
          { title: 'Lyrical 1', start: '5:15', end: '5:45' },
          { title: 'Contemporary 1', start: '6:45', end: '7:30' }
        ],
        w: [
          { title: 'Ballet 1', start: '5:00', end: '5:30' },
          { title: 'Ballet 2', start: '5:30', end: '6:00' },
          { title: 'Ballet 3', start: '6:00', end: '6:45' }
        ],
        th: [
          { title: 'Jazz 1', start: '5:15', end: '6:00' }
        ]
      }
    }, {
      name: 'Intermediate',
      req: 'Teacher placement',
      classes: {
        t: [
          { title: 'Contemporary 2', start: '8:00', end: '8:30' }
        ],
        w: [
          { title: 'Ballet 4', start: '7:15', end: '8:15' }
        ],
        th: [
          { title: 'Jazz 2', start: '7:15', end: '8:15' }
        ]
      }
    }, {
      name: 'Adult',
      desc: 'Ages 18+',
      classes: {
        sun: [
          { title: 'Belly dancing', start: '4:00', end: '5:00' }
        ]
      }
    }, {
      name: 'Other',
      classes: {
        m: [
          { title: 'FREE Stretch & Conditioning', desc: 'All ages', start: '6:45', end: '7:15' }
        ],
        t: [
          { title: 'Leaps and Turns', start: '6:15', end: '6:45' }
        ],
        th: [
          { title: 'Stretch', start: '6:30', end: '6:45' },
          { title: 'Turns and leaps', start: '6:45', end: '7:15' }
        ],
        f: [
          { title: 'Tumbling 1', start: '5:30', end: '6:00' },
          { title: 'Tumbling 2', start: '6:30', end: '7:15' }
        ]
      }
    }]
  }
}
